export default __webpack_public_path__ + "static/media/movingGradation.6bceffe1.webp";